import tw from "twin.macro";

export const UserInformationMenu = tw.div`
  bg-white
  p-6
  shadow-md
  rounded
  text-[#6e6e6e]
`;
